import { Injectable, inject } from '@angular/core';

import { UrlParam } from '@frontend/sports/navigation/core/feature/url-builder';
import { MarketUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { BetslipType } from '../../../core/betslip-type';
import { BetslipLinearTracking, BetslipTrackingConstants, PickBetTrackingTypes } from '../../tracking/models';

@Injectable()
export class BetslipTrackingSelectionService {
    private trackingService = inject(TrackingService);
    private urlHelperService = inject(UrlHelperService);

    trackBetSlipsSelection(betslipType: BetslipType, fixture: { id: string; name: string }): void {
        const eventDetails = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: BetslipTrackingConstants.CategoryEvent,
            [trackingConstants.COMPONENT_LABEL_EVENT]: BetslipTrackingConstants.LabelEvent,
            [trackingConstants.COMPONENT_ACTION_EVENT]: BetslipTrackingConstants.Click,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: BetslipLinearTracking.LinearCheckbox,
            [trackingConstants.COMPONENT_POSITION_EVENT]: this.getBetTypeLocation(betslipType),
            [trackingConstants.COMPONENT_EVENT_DETAILS]: BetslipLinearTracking.BetSlipSelection,
            [trackingConstants.COMPONENT_URL_CLICKED]: this.getFixtureUrl(fixture),
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, eventDetails);
    }

    private getFixtureUrl(event: UrlParam, market?: MarketUrlParam): string {
        const evtRelativeUrl = this.urlHelperService.getEventUrl(event, market);
        return this.urlHelperService.getAbsolute(evtRelativeUrl);
    }

    private getBetTypeLocation(betType: BetslipType): string {
        switch (betType) {
            case BetslipType.Combo:
                return PickBetTrackingTypes.Parlay;
            case BetslipType.Single:
                return PickBetTrackingTypes.Single;
            case BetslipType.System:
                return PickBetTrackingTypes.System;
            case BetslipType.Teaser:
                return PickBetTrackingTypes.Teaser;
            default:
                return 'Unknown';
        }
    }
}
